import { FC, useCallback } from 'react'

import { Country } from '@/interfaces/billing'

import { CountrySelector } from './CountrySelector'
import { PhoneInput } from './PhoneInput'

interface CountryPhoneSelectorProps {
  _value?: { number: string; codeCountry: string }
  onChange: (_value: { number: string; codeCountry: string }) => void
  placeholder?: string
  disabled?: boolean
  className?: string
}

export const CountryPhoneSelector: FC<CountryPhoneSelectorProps> = ({
  _value,
  onChange,
  placeholder = 'Número de teléfono',
  disabled = false,
  className,
}) => {
  // Handle country selection change
  const handleCountryChange = useCallback(
    (country: Country) => {
      onChange({
        number: _value?.number || '',
        codeCountry: country.prefix,
      })
    },
    [_value?.number, onChange]
  )

  // Handle phone number change
  const handlePhoneChange = useCallback(
    (phoneNumber: string) => {
      onChange({
        number: phoneNumber,
        codeCountry: _value?.codeCountry || '+53',
      })
    },
    [_value?.codeCountry, onChange]
  )

  return (
    <div className="flex gap-2">
      <CountrySelector
        className={className}
        compactMode={true}
        contentClassName="w-[220px]"
        disabled={disabled}
        onChange={handleCountryChange}
        searchPlaceholder="Buscar país o código..."
        showFlag={true}
        showPrefix={true}
        triggerClassName="w-[120px]"
        value={_value?.codeCountry}
        valueType="prefix"
      />
      <div className="flex-1">
        <PhoneInput
          className={className}
          disabled={disabled}
          onChange={handlePhoneChange}
          placeholder={placeholder}
          value={_value?.number}
        />
      </div>
    </div>
  )
}
